export const NoSubItemsIcon = () => {
  return (
    <svg
      width="131"
      height="125"
      viewBox="0 0 131 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>No Sub-Items Found</title>
      <g clipPath="url(#clip0_4880_57395)">
        <path d="M127.049 3.43359H54.3594V121.621H127.049V3.43359Z" fill="#69F6FF" />
        <path d="M78.4316 101.027H3.95068V121.623H78.4316V101.027Z" fill="#9563FF" />
        <path d="M78.4316 74.4609H3.95068V95.0566H78.4316V74.4609Z" fill="#9563FF" />
        <path d="M78.4316 47.8477H3.95068V68.4434H78.4316V47.8477Z" fill="#9563FF" />
        <path d="M78.4316 21.2812H3.95068V41.8769H78.4316V21.2812Z" fill="#9563FF" />
        <path
          d="M55.4128 121.621H108.508V111.957H62.0497L111.194 62.6855L104.347 55.8203L55.4128 104.933V58.7248H45.7734V111.957V121.621H55.4128Z"
          fill="#1B1B1D"
        />
      </g>
      <defs>
        <clipPath id="clip0_4880_57395">
          <rect width="131" height="125" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
